export default "__VITE_ASSET___C7GAEyf__"